/* eslint-disable @typescript-eslint/no-explicit-any */
import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
import { userDTO, Course } from "../../types/types";

export type RequestsDTO = {
    id: string;
    studentId: string;
    courseId: string;
    status: string;
    student: userDTO;
    course: Course;
    egp: boolean;
};

export interface MetaData {
    currentPage: number;
    nextPage: number;
    previousPage: number;
    totalPages: number;
}

interface RequestsData {
    metaData: MetaData;
    requests: RequestsDTO[];
}

interface RequestsResponse {
    data?: RequestsData;
    error?: ApiError;
}

export interface GetRequestsParams {
    page: number;
    limit: number;
    status?: string;
    firstName?: string;
    phone?: string;
    courseName?: string;
}

export const GetRequests = async (params: GetRequestsParams): Promise<RequestsResponse> => {
    try {
        const response = await axios.get('/course/requests/allEnrollRequest', {
            params: {
                page: params.page,
                limit: params.limit,
                status: params.status,
                firstName: params.firstName,
                phone: params.phone,
                courseName: params.courseName,
            },
        });
            return { data: response.data };
    } catch (error: any) {
        console.error("API Error:", error);
        if (error.response) {
            const apiError: ApiError = {
                statusCode: error.response.status,
                message: error.response.data.message,
                error: error.response.data.error,
            };
            return { error: apiError };
        } else {
            const fallbackError: ApiError = {
                statusCode: 500,
                message: "An unexpected error occurred",
            };
            return { error: fallbackError };
        }
    }
};
